"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var css = require("./index.scss");
var ripple_1 = require("@material/ripple");
require("../icon");
//@ts-ignore
require("../theme.ts");
var Chips = /** @class */ (function (_super) {
    __extends(Chips, _super);
    function Chips() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.trailingClickHandle = function (index) {
            _this.fire('trailingIconInteraction', index);
        };
        _this.chipClickHandle = function (index) {
            _this.fire('interaction', index);
        };
        return _this;
    }
    Chips.prototype.installed = function () {
        if (this.props.ripple) {
            this.shadowRoot.querySelectorAll('.mdc-chip').forEach(function (item) {
                new ripple_1.MDCRipple(item);
            });
        }
    };
    Chips.prototype.render = function (props) {
        var _this = this;
        return (omi_1.h("div", __assign({}, omi_1.extractClass(props, 'mdc-chip-set', {
            'mdc-chip-set--input': props.input,
            'mdc-chip-set--choice': props.choice,
            'mdc-chip-set--filter': props.filter
        })), props.chips.map(function (item, index) {
            return omi_1.h("div", __assign({ tabindex: "0" }, omi_1.extractClass(props, 'mdc-chip', {
                'mdc-chip--selected': item.selected
            }), { onClick: function () { return _this.chipClickHandle(index); } }),
                (item.leading) && omi_1.h("i", { class: omi_1.classNames('material-icons', 'mdc-chip__icon', 'mdc-chip__icon--leading', { 'mdc-chip__icon--leading-hidden': props.filter && item.checkmark && item.selected }) },
                    (item.leading.icon && typeof item.leading.icon === 'object') && omi_1.h("m-icon", __assign({ class: 'm-icon' }, item.leading.icon)),
                    (item.leading.icon && typeof item.leading.icon === 'string') && item.leading.icon),
                (props.filter && item.checkmark) && omi_1.h("div", { class: "mdc-chip__checkmark" },
                    omi_1.h("svg", { class: "mdc-chip__checkmark-svg", viewBox: "-2 -3 30 30" },
                        omi_1.h("path", { class: "mdc-chip__checkmark-path", fill: "none", stroke: "black", d: "M1.73,12.91 8.1,19.28 22.79,4.59" }))),
                omi_1.h("div", { class: "mdc-chip__text" }, item.text),
                (item.trailing) && omi_1.h("i", { class: "material-icons mdc-chip__icon mdc-chip__icon--trailing", onClick: function () { return _this.trailingClickHandle(index); } },
                    (item.trailing.icon && typeof item.trailing.icon === 'object') && omi_1.h("m-icon", __assign({ class: 'm-icon' }, item.trailing.icon)),
                    (item.trailing.icon && typeof item.trailing.icon === 'string') && item.trailing.icon));
        })));
    };
    Chips.css = css;
    Chips.defaultProps = {
        ripple: true
    };
    Chips.propTypes = {
        ripple: Boolean,
        chips: Object,
        input: Boolean,
        choice: Boolean,
        filter: Boolean
    };
    Chips = __decorate([
        omi_1.tag('m-chips')
    ], Chips);
    return Chips;
}(omi_1.WeElement));
exports.default = Chips;
